/**
 * General Anaesthetic & Castrate Consent template.
 */
import { Text } from '@react-pdf/renderer'

import {
  ANAESTHESIA_RISK_CLAUSE,
  COST_ACCEPTANCE_CLAUSE,
  DISCHARGE_TIME_CLAUSE,
  EMERGENCY_AUTH_CLAUSE,
  IV_FLUIDS_CLAUSE,
  NATURE_EXPLAINED_CLAUSE,
  OFF_LABEL_MEDICINES_CLAUSE,
  PERMISSION_CLAUSE,
  VET_BEST_INTEREST_CLAUSE,
} from '@/frontend/features/printing/documents/consent/clauses'
import { buildPreOpConsentForm } from '@/frontend/features/printing/documents/consent/consent-template.form'

const consentText = (name: string) =>
  `I am the owner or authorised agent for the owner of ${name}. I give my consent for Snoots to perform a general anaesthetic & castration.`

export const castrateConsent = buildPreOpConsentForm({
  id: 'castrate-consent',
  label: 'Castrate Consent',
  title: 'GENERAL ANAESTHETIC & CASTRATE CONSENT',
  renderConsentPreview: ({ patientName }) => <p>{consentText(patientName)}</p>,
  renderConsentPrint: ({ patientName }) => (
    <Text style={{ fontSize: 10 }}>{consentText(patientName)}</Text>
  ),
  clauses: [
    PERMISSION_CLAUSE,
    NATURE_EXPLAINED_CLAUSE,
    ANAESTHESIA_RISK_CLAUSE,
    COST_ACCEPTANCE_CLAUSE,
    VET_BEST_INTEREST_CLAUSE,
    OFF_LABEL_MEDICINES_CLAUSE,
    EMERGENCY_AUTH_CLAUSE,
    IV_FLUIDS_CLAUSE,
    DISCHARGE_TIME_CLAUSE,
  ],
})
